import { render, staticRenderFns } from "./ExamIntermediateComponent.vue?vue&type=template&id=16163d6c&scoped=true&"
import script from "./ExamIntermediateComponent.vue?vue&type=script&lang=js&"
export * from "./ExamIntermediateComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExamIntermediateComponent.vue?vue&type=style&index=0&id=16163d6c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16163d6c",
  null
  
)

export default component.exports